import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { deleteCustomReport } from '../../service/customReportService'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import customReportQueryKeys from '../customReportQueryKeys'
import { showDeleteSuccessMessage, showErrorMessage } from '../../../../utils/message'

export const useCtxDeleteCustomReport = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      if (!id) {
        throw new Error('Report ID is required')
      }
      return deleteCustomReport(companyId, id)
    },
    onSuccess: () => {
      showDeleteSuccessMessage()
      return queryClient.invalidateQueries({
        queryKey: customReportQueryKeys.list(companyId)
      })
    },
    onError: () => {
      showErrorMessage()
    }
  })
}
